import { Container, Box, Grid, GridItem, Heading, Text, Flex } from '@chakra-ui/react';
import ImageShimmer from '../ImageShimmer/ImageShimmer';

export default function LogoWall({ title, text }: { title: string; text: string }) {
  const companies = [
    {
      name: 'Hims & Hers',
      imageSrc: '/images/light-lp/companies/hims-hers.svg',
      imageSize: {
        w: 151,
        h: 24,
      },
    },
    {
      name: 'Gusto',
      imageSrc: '/images/light-lp/companies/gusto.svg',
      imageSize: {
        w: 84,
        h: 33,
      },
    },
    {
      name: 'Nextdoor',
      imageSrc: '/images/light-lp/companies/nextdoor.svg',
      imageSize: {
        w: 146,
        h: 21,
      },
    },
    {
      name: 'Dialpad',
      imageSrc: '/images/light-lp/companies/dialpad.svg',
      imageSize: {
        w: 144,
        h: 27,
      },
    },
    {
      name: 'Chime',
      imageSrc: '/images/light-lp/companies/chime.svg',
      imageSize: {
        w: 95,
        h: 30,
      },
    },
    {
      name: 'Earnin',
      imageSrc: '/images/light-lp/companies/earnin.svg',
      imageSize: {
        w: 125,
        h: 31,
      },
    },
  ];

  return (
    <Box bgColor="grey.100" py={{ base: '12', lg: '20' }}>
      <Container>
        <Heading
          as="h2"
          textAlign={{ lg: 'center' }}
          fontSize={{ base: '2.5rem', lg: '3rem' }}
          lineHeight={{ base: '3rem', lg: '3.5rem' }}
          mb="4"
        >
          {title}
        </Heading>
        <Text
          textAlign={{ lg: 'center' }}
          fontSize={{ base: '1rem', lg: '1.125rem' }}
          lineHeight={{ base: '1.25rem', lg: '1.5rem' }}
        >
          {text}
        </Text>
        <Grid
          mt={{ base: '7', lg: '9' }}
          templateColumns={{
            base: 'repeat(3, 1fr)',
            md: 'repeat(6, 1fr)',
          }}
          gap={{ base: '2rem 1rem', lg: '20' }}
        >
          {companies.map((company) => (
            <GridItem key={company.name}>
              <Flex h="100%" alignItems="center" justifyContent="center">
                <ImageShimmer
                  src={company.imageSrc}
                  alt={company.name}
                  width={company.imageSize.w}
                  height={company.imageSize.h}
                  style={{ objectFit: 'cover' }}
                  layout="intrinsic"
                />
              </Flex>
            </GridItem>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
